import * as React from 'react';
import { observer } from 'mobx-react';
import { LiveEventStore } from '../../models/live/liveEvent';
import { IMtsTicketStore } from 'eTip--common';
import { EventDetailRawContainer } from './eventDetailRawContainer';
import { Instance } from 'mobx-state-tree';

export interface IEventListDetailConteinerProps {
    detail: Instance<typeof LiveEventStore>;
    ticketWrapper: IMtsTicketStore;
    showHeader: boolean;
    isMatchTracker?: boolean;
    canShowLiveEventDetailGroupTabs: boolean;
    matchTrackerClick?: () => void | null;
    canClearStoreOnUmount: boolean;
}

export const EventListDetailContainer: React.FC<IEventListDetailConteinerProps> = observer((props: IEventListDetailConteinerProps) => {
    return (
        <EventDetailRawContainer
            store={props.detail}
            ticketWrapper={props.ticketWrapper}
            eventId={props.detail.id}
            canShowRemove={false}
            canShowInTabs={props.canShowLiveEventDetailGroupTabs}
            isMatchTracker={props.isMatchTracker}
            matchTrackerClick={props.matchTrackerClick}
            canOpenLiveStreamAfterLoad={false}
            isLiveStreamAllowed={true}
            isMatchTrackerAllowed={true}
            isDetailInList={true}
            canClearStoreOnUmount={props.canClearStoreOnUmount}
        />
    );
});
